const d="md-slider{width:var(--cds-slider-width, 100%)}";export{d as default};
